/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { CultBinder, CultBinderInterface } from "../CultBinder";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "active",
        type: "bool",
      },
    ],
    name: "BindingLockupActive",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldLockup",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newLockup",
        type: "uint256",
      },
    ],
    name: "BindingLockupChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum Cult",
        name: "cult",
        type: "uint8",
      },
    ],
    name: "OwnerBound",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum Cult",
        name: "cult",
        type: "uint8",
      },
    ],
    name: "OwnerUnbound",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress_",
        type: "address",
      },
    ],
    name: "__TrustedForwarderRecipientUpgradeable_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "amIBound",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Cult",
        name: "cult",
        type: "uint8",
      },
    ],
    name: "bindOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "binderCults",
    outputs: [
      {
        internalType: "enum Cult",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "binders",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bindersCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Cult",
        name: "cult",
        type: "uint8",
      },
    ],
    name: "bindersCountForCult",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bindingLockup",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "boundAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "cultForOwner",
    outputs: [
      {
        internalType: "enum Cult",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBinders",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDeployedBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSecondsPerBlock",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isBound",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isOwnerBound",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lockupActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "lockupExpiryFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "lockupRemainingFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "myCult",
    outputs: [
      {
        internalType: "enum Cult",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "ownersBoundAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "secondsPerBlock",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newLockup",
        type: "uint256",
      },
    ],
    name: "setBindingLockup",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarder_",
        type: "address",
      },
    ],
    name: "setForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "active",
        type: "bool",
      },
    ],
    name: "setLockupActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "blocks",
        type: "uint16",
      },
    ],
    name: "setSecondsPerBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unbindOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

type CultBinderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CultBinderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CultBinder__factory extends ContractFactory {
  constructor(...args: CultBinderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CultBinder";
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CultBinder> {
    return super.deploy(overrides || {}) as Promise<CultBinder>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): CultBinder {
    return super.attach(address) as CultBinder;
  }
  override connect(signer: Signer): CultBinder__factory {
    return super.connect(signer) as CultBinder__factory;
  }
  static readonly contractName: "CultBinder";

  public readonly contractName: "CultBinder";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CultBinderInterface {
    return new utils.Interface(_abi) as CultBinderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CultBinder {
    return new Contract(address, _abi, signerOrProvider) as CultBinder;
  }
}
